import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArcButton, ArcStack } from '@src/core/ui';
import { routesConfig } from '@src/core/routes';
import { MissionIdParams } from '@src/core/entities';
import { useCancelMissionMutation, useTakeOffMutation, useGetOrderMissionQuery } from '@src/features/order/redux';
import { toast } from 'react-toastify';
import { SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType, UnitSystemType } from '@src/core/enums';
import { ChecklistActionsProps } from './types';

const ChecklistActions: React.FC<ChecklistActionsProps> = ({ allChecked }) => {
  const navigate = useNavigate();
  const { missionId } = useParams<MissionIdParams>();
  const { data } = useGetOrderMissionQuery(missionId);
  const [cancelMission, { isLoading: isCanceling }] = useCancelMissionMutation();
  const [takeOff, { isLoading: isTakingOff }] = useTakeOffMutation();

  const handleCancel = () => {
    if (!missionId) return;
    cancelMission(missionId).unwrap().then(() => {
      toast.success('Mission has been canceled');
      navigate(routesConfig.orders, { replace: true });
    }).catch(() => {});
  };

  const handleExit = () => {
    navigate(routesConfig.orders);
  };

  const handleTakeOff = () => {
    if (!missionId || !allChecked) return;
    const unitSystem = localStorage.getItem(SETTING_UNITS_KEY) === UnitType.SI ? UnitSystemType.METRIC : UnitSystemType.IMPERIAL;
    takeOff({ missionId, unitSystem }).unwrap().then(() => {
      navigate(`${routesConfig.drones}?droneSerial=${data?.drone.serialNumber}&missionId=${missionId}`);
      toast.success('Take Off Success Text');
    }).catch(() => {
      // Error toast handled by rtkErrorLogger middleware
    });
  };

  return (
    <ArcStack spacing={1} width='100%'>
      <ArcStack direction='row' spacing={1}>
        <ArcButton.ghost 
          fullWidth 
          isLoading={isCanceling} 
          onClick={handleCancel}
        > 
          CANCEL 
        </ArcButton.ghost>
        <ArcButton.ghost 
          fullWidth 
          onClick={handleExit}
        > 
          EXIT 
        </ArcButton.ghost>
      </ArcStack>
      <ArcButton.brand 
        fullWidth
        disabled={!allChecked}
        isLoading={isTakingOff}
        onClick={handleTakeOff}
      > 
        TAKEOFF 
      </ArcButton.brand>
    </ArcStack>
  );
};

export default ChecklistActions;

